import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { books } from '../data/books';
import { BookCover3D } from './BookCover3D';
import { SectionShell } from './SectionShell';
export function BooksSection() {
  return <SectionShell id="ebooks" eyebrow="Los 5 ebooks — detalle completo" title="Cinco volúmenes. Un sistema que se sostiene solo." subtitle="Cada libro resuelve una parte específica del problema. Juntos cubren el recorrido completo: de la primera mirada a la conexión real." className="border-y border-gold-500/10 bg-noir-900" data-id="element-15" data-mp="2sx9lw7yqmhcq">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 sm:gap-20 lg:gap-24" data-id="element-16" data-mp="3ck7b2kentjm6">
        {books.map((book, index) => {
        const reversed = index % 2 === 1;
        return <motion.article key={book.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-90px'
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="grid items-center gap-6 sm:gap-10 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16" data-id="element-17" data-mp="3lklx5lzg72qq" data-mpi={index}>
              <div className={reversed ? 'lg:order-2' : ''} data-id="element-18" data-mp="1kqzglg6z3jzd">
                <motion.div initial={{
              rotateY: reversed ? 18 : -18,
              opacity: 0
            }} whileInView={{
              rotateY: reversed ? 6 : -6,
              opacity: 1
            }} viewport={{
              once: true,
              margin: '-90px'
            }} transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1]
            }} className="perspective-[1400px] mx-auto w-[58%] max-w-[300px] sm:w-[52%] lg:w-full" data-id="element-19" data-mp="1frd4ja2vs9s5">
                  <BookCover3D src={book.cover} alt={`Portada de ${book.title}`} intensity={14} data-id="element-20" data-mp="1yowc099oxkcg" />
                </motion.div>
              </div>

              <div className={`text-left ${reversed ? 'lg:order-1' : ''}`} data-id="element-21" data-mp="2rdbr0vsto2ns">
                <div className="flex flex-wrap items-center gap-2.5 sm:gap-3" data-id="element-22" data-mp="3ac6jfjzg6g70">
                  <span className="inline-flex items-center gap-2 rounded-full border border-gold-500/30 bg-gold-500/[0.07] px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-widest2 text-gold-400" data-id="element-23" data-mp="3fa81c1l509gw">
                    Volumen {book.volume}
                  </span>
                  <span className="inline-flex items-center rounded-full border border-cream/12 bg-noir-800 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cream/55" data-id="element-24" data-mp="2rkdq1oggusyr">
                    Valor: {book.value}
                  </span>
                </div>

                <h3 className="mt-4 font-display text-[1.65rem] font-bold leading-tight text-cream sm:mt-5 sm:text-[2rem]" data-id="element-25" data-mp="2ilsbs5i1203s">
                  {book.title}
                </h3>
                <p className="mt-3 border-l-2 border-crimson-600 pl-4 font-display text-[15px] italic leading-relaxed text-gold-400 sm:text-lg" data-id="element-26" data-mp="gtnmz2vtrixa">
                  “{book.promise}”
                </p>
                <p className="mt-4 text-[15px] leading-relaxed text-cream/62 sm:mt-5" data-id="element-27" data-mp="25crrbh3do9o6">
                  {book.intro}
                </p>

                <p className="mt-6 text-[11px] font-bold uppercase tracking-widest2 text-cream/45 sm:mt-7" data-id="element-28" data-mp="218k63tw4pbup">
                  Lo que obtienes
                </p>
                <ul className="mt-3.5 space-y-2.5 sm:mt-4 sm:space-y-3" data-id="element-29" data-mp="2a9i9qb2nnhcr">
                  {book.bullets.map(bullet => <li key={bullet} className="flex gap-3" data-id="element-30" data-mp="2p228z0mop4ox">
                      <ArrowRight className="mt-1 h-4 w-4 shrink-0 text-crimson-500" aria-hidden="true" data-id="element-31" data-mp="2jztgs6hmy6nv" />
                      <span className="text-[15px] leading-relaxed text-cream/72" data-id="element-32" data-mp="2t11dik4i6zfu">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.article>;
      })}
      </div>
    </SectionShell>;
}